import { render, staticRenderFns } from "./ServiceHandbook.vue?vue&type=template&id=e2bcc692"
import script from "./ServiceHandbook.vue?vue&type=script&lang=js"
export * from "./ServiceHandbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports